import { CloseOutlined } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Card,
  Dialog,
  Divider,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Toolbar,
} from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { numberValidation } from "layouts/views/common/validation";
import { useEffect, useState } from "react";
import { getAvailableLocations } from "services/data.outbound.service";
import { updateSave } from "services/data.outbound.service";
import { updateAllocate } from "services/data.outbound.service";
import { getAllocatedOptions } from "services/data.outbound.service";
import { updatePreview } from "services/data.outbound.service";
import { getPickslipsDetails } from "services/data.outbound.service";
import { getPickslips } from "services/data.outbound.service";
import { Success, Error_ } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { InfoButton } from "ui-components/Button";
import { SelectFields } from "ui-components/Form";
import { EditButton } from "ui-components/IconButton";
import { StatusDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { StripedCheckboxDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import {
  allocateColumns,
  availableColumns,
  pickslipColumns,
  previewColumns,
  selectedSkuColumns,
  skuColumns,
} from "./picking-amend/columns";
import { getAmendDetails } from "services/data.outbound.service";

function AmendPickslip({ customerCode }) {
  const [options, setOptions] = useState({ orders: [], waves: [] });
  const [waveSKU, setWaveSKU] = useState([]);
  const [selectedSKU, setSelectedSKU] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [waveNumber, setWaveNumber] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [open, setOpen] = useState(false);

  const { isFetching } = useQuery({
    queryKey: ["wave-options", { customerCode }],
    queryFn: () => getAllocatedOptions({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setOptions(data.data.data),
  });

  const { isFetching: isPickslipsFetching, refetch } = useQuery({
    queryKey: ["wave-sku", { orderNumber, waveNumber }],
    queryFn: () => getPickslips({ orderNumber: orderNumber ?? "", waveNumber: waveNumber ?? "" }),
    enabled: Boolean(orderNumber) || Boolean(waveNumber),
    onSuccess: (data) => setWaveSKU(data.data.data.map((x, index) => ({ ...x, id: index + 1 }))),
  });

  return (
    <>
      <Card sx={{ mt: 2, p: 2 }}>
        {(isFetching || isPickslipsFetching) && <LoadingDialog />}
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <SelectFields
              options={options.orders}
              field={{ label: "Order Number", value: orderNumber, name: "orderNumber", errors: {} }}
              onChange={(e, v) => {
                setOrderNumber(v);
                setWaveNumber(null);
                setSelectedId([]);
                setSelectedSKU([]);
                setWaveSKU([]);
              }}
            />
          </Grid>
          {/* <Grid item>
            <InfoButton onClick={refetch} disabled={!Boolean(orderNumber)}>
              Retrieve
            </InfoButton>
          </Grid> */}
          <Grid item xs={4}>
            <SelectFields
              options={options.waves}
              field={{ label: "Wave Number", value: waveNumber, name: "waveNumber", errors: {} }}
              onChange={(e, v) => {
                setWaveNumber(v);
                setOrderNumber(null);
                setSelectedId([]);
                setSelectedSKU([]);
                setWaveSKU([]);
              }}
            />
          </Grid>
          {/* <Grid item>
            <InfoButton onClick={refetch} disabled={!Boolean(waveNumber)}>
              Retrieve
            </InfoButton>
          </Grid> */}
        </Grid>

        <MDTypography color="info" variant="h5">
          SKU Code
        </MDTypography>
        <StripedCheckboxDataGrid
          columns={skuColumns}
          rows={waveSKU}
          onRowSelectionModelChange={(id) => setSelectedId(id)}
          rowSelectionModel={selectedId}
        />
        <MDBox display="flex" justifyContent="center" alignItems="center" mt={2}>
          <InfoButton
            onClick={() => {
              setSelectedSKU(waveSKU.filter((x) => selectedId.includes(x.id)));
              setOpen(true);
            }}
            disabled={selectedId.length === 0}
          >
            Edit
          </InfoButton>
        </MDBox>
      </Card>
      <UpdateModal
        waveNumber={waveNumber}
        orderNumber={orderNumber}
        selectedSKU={selectedSKU}
        open={open}
        setOpen={setOpen}
        refetch={refetch}
      />
    </>
  );
}

export default AmendPickslip;

const UpdateModal = ({
  waveNumber = null,
  orderNumber = null,
  selectedSKU = [],
  open,
  setOpen,
  refetch,
}) => {
  const [skuCode, setSKUCode] = useState(null);
  const [totalAllocate, setTotalAllocate] = useState(0);
  const [locations, setLocations] = useState([]);
  const [preview, setPreview] = useState([]);
  const [allocate, setAllocate] = useState([]);
  const [alert, setAlert] = useState(null);
  const [saveAlert, setSaveAlert] = useState(null);
  const [pickslipDetails, setPickslipDetails] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState([]);
  const [selectedCurrentLocationId, setSelectedCurrentLocationId] = useState([]);
  const totalQuantityPicked = pickslipDetails.reduce((total, detail) => {
    total = detail.quantityPicked + total;
    return total;
  }, 0);
  const totalQuantityPicked2 = preview.reduce((total, detail) => {
    if (detail.status !== "C") {
      total = detail.quantityPicked + total;
    }
    return total;
  }, 0);
  const totalAllocateQuantityPicked = allocate.reduce((total, detail) => {
    if (detail.status !== "C") {
      total = detail.quantityPicked + total;
    }

    return total;
  }, 0);
  const totalQuantityAllocate = allocate.reduce((total, detail) => {
    total = detail.quantityAllocate + total;

    return total;
  }, 0);
  useEffect(() => {
    setSKUCode(null);
    setLocations([]);
    setPreview([]);
    setAllocate([]);
    setPickslipDetails([]);
    setSelectedLocationId([]);
    setSelectedCurrentLocationId([]);
    setTotalAllocate(0);
    setAlert(null);
  }, [open]);

  useEffect(() => {
    if (open) {
      if (selectedSKU.length > 0) {
        setSKUCode(selectedSKU[0].skuCode);
      }
    }
  }, [open]);
  useEffect(() => {
    setPreview([]);
  }, [skuCode]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const queryClient = useQueryClient();

  const {isFetching} = useQuery({
    queryKey: ["amend", "details", { skuCode }],
    queryFn: () =>
      getAmendDetails({ orderNumber: orderNumber ?? "", waveNumber: waveNumber ?? "", skuCode }),
    enabled: (Boolean(waveNumber) || Boolean(orderNumber)) && Boolean(skuCode),
    onSuccess: (data) => {
      const {details,locations} = data.data.data
      setPickslipDetails(details);
      setLocations(locations.map(x=>({id:x.palletNbr,...x})))
    },
  });

  // const { isFetching } = useQuery({
  //   queryKey: ["amend", "pickslips-details", { skuCode }],
  //   queryFn: () =>
  //     getPickslipsDetails({
  //       orderNumber: orderNumber ?? "",
  //       waveNumber: waveNumber ?? "",
  //       skuCode,
  //     }),
  //   enabled: (Boolean(waveNumber) || Boolean(orderNumber)) && Boolean(skuCode),
  //   onSuccess: (data) => {
  //     setTotalAllocate(data.data.data.totalQuantityAllocate);
  //     setPickslipDetails(data.data.data.list);
  //   },
  // });
  // const { isFetching: isLocationsFetching } = useQuery({
  //   queryKey: ["amend", "available-locations", { skuCode }],
  //   queryFn: () =>
  //     getAvailableLocations({
  //       orderNumber: orderNumber ?? "",
  //       waveNumber: waveNumber ?? "",
  //       skuCode,
  //     }),
  //   enabled: (Boolean(waveNumber) || Boolean(orderNumber)) && Boolean(skuCode),
  //   onSuccess: (data) => setLocations(data.data.data.map((x) => ({ id: x.palletNbr, ...x }))),
  // });
  const saveMutation = useMutation(updatePreview, {});
  const updateMutation = useMutation(updateSave, {});
  const allocateMutation = useMutation(updateAllocate, {});

  useEffect(() => {
    console.log(pickslipDetails);
    setLocations(
      locations.map((x) => {
        if (pickslipDetails.includes((d) => d.palletNbr == x.palletNbr)) {
          console.log(1);
          return { ...x, status: "O" };
        }
        return x;
      })
    );
  }, [pickslipDetails]);

  const saveStatus = saveMutation.status === "loading";
  const updateStatus = updateMutation.status === "loading";
  return (
    <Dialog fullScreen open={open} sx={{ padding: 1 }}>
      <AppBar sx={{ position: "relative", background: "#f5f5f5" }}>
        <Toolbar>
          <IconButton
            onClick={() => {
              queryClient.invalidateQueries(["wave-sku"]);
              setOpen(false);
            }}
          >
            <CloseOutlined />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2 }}>
        {alert}
        <MDTypography color="info" variant="h5">
          Selected SKU Code List
        </MDTypography>
        <StatusDataGrid
          columns={selectedSkuColumns}
          rows={selectedSKU}
          onRowClick={(x) => {
            setSKUCode(x.row.skuCode);
          }}
          disableRowSelectionOnClick={false}
          //onRowSelectionModelChange={(id) => setSelectedId(id)}
          //rowSelectionModel={selectedId}
        />

        {/* <Paper sx={{ maxWidth: "100%", border: "1px solid #9ebeeb", boxShadow: 0 }}>
          <MenuList sx={{ overflow: "auto", height: "200px" }}>
            {selectedSKU.map((x) => (
              <MenuItem
                key={x.skuCode}
                selected={x.skuCode === skuCode}
                sx={{ borderBottom: "1px solid #9ebeeb" }}
                onClick={() => setSKUCode(x.skuCode)}
              >
                <ListItemText>{x.skuCode} </ListItemText>
              </MenuItem>
            ))}
          </MenuList>
        </Paper> */}
        <Grid container spacing={5}>
          <Grid item xs={6} mt={2}>
            <MDTypography color="info" variant="h5">
              Available Location
            </MDTypography>
            <StatusDataGrid
              columns={availableColumns}
              rows={locations.map((x) => {
                if (pickslipDetails.some((d) => d.palletNbr === x.palletNbr)) {
                  return { ...x, status: "O" };
                }
                return x;
              })}
              onRowSelectionModelChange={(id) => setSelectedLocationId(id)}
              isRowSelectable={(params) =>
                !pickslipDetails.some((x) => x.palletNbr === params.row.palletNbr)
              }
              checkboxSelection={true}
            />
            <MDBox display="flex" justifyContent="flex-end" mt={2}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  //const filtered = locations.filter((x) => !selectedLocationId.includes(x.id));
                  //setLocations(filtered);
                  const data = locations.filter((x) => selectedLocationId.includes(x.id));
                  const details = data.map((x) => ({
                    ...x,
                    totalQuantityAllocate: 0,
                    quantityAllocate: 0,
                    quantityPicked: 0,
                  }));
                  setPickslipDetails([...pickslipDetails, ...details]);
                }}
                disabled={selectedLocationId.length === 0}
              >
                Move Location
              </MDButton>
            </MDBox>
          </Grid>
          <Grid item xs={6} mt={2}>
            {isFetching && <LoadingDialog />}
            <MDTypography color="info" variant="h5">
              Pickslips Details
            </MDTypography>
            <Box sx={{ "& .bold": { fontWeight: 1000, background: "mintcream" } }}>
              <StripedCheckboxDataGrid
                columns={pickslipColumns}
                rows={[
                  ...pickslipDetails,
                  {
                    id: "Total",
                    label: "Total",
                    //totalQuantityAllocate: totalAllocate,
                    //quantityAllocate: totalAllocate,
                    quantityPicked: totalQuantityPicked,
                  },
                ]}
                processRowUpdate={(updatedRow, originalRow) => {
                  let qtyUpdated = numberValidation(updatedRow.quantityPicked);
                  // if (updatedRow.quantityAllocate > 0 && qtyUpdated > updatedRow.quantityAllocate) {
                  //   qtyUpdated = updatedRow.quantityAllocate;
                  // }
                  const location = locations.find(x=>x.palletNbr === updatedRow.palletNbr)
                  if(qtyUpdated > location.remainingStockQuantity){
                    qtyUpdated = location.remainingStockQuantity
                  }
                  const details = pickslipDetails.map((x) => {
                    if (x.id === updatedRow.id) {
                      x.quantityPicked = qtyUpdated;
                      originalRow.quantityPicked = qtyUpdated;
                    }
                    return x;
                  });
                  setPickslipDetails(details);
                  return originalRow;
                }}
                onProcessRowUpdateError={(x) => {
                  console.log(x);
                }}
                onRowSelectionModelChange={(id) => {
                  setSelectedCurrentLocationId(id);
                }}
                getCellClassName={({ row, field }) => {
                  if (row.id === "Total") {
                    if (
                      field === "zoneID" ||
                      field === "totalQuantityAllocate" ||
                      field === "quantityAllocate" ||
                      field === "quantityPicked"
                    ) {
                      return "bold";
                    }
                  }
                  return "";
                }}
                isRowSelectable={(params) => !(params.row.id === "Total")}
                isCellEditable={(params) => !(params.row.id === "Total")}
              />
            </Box>

            <MDBox display="flex" justifyContent="flex-end" mt={2}>
              <MDButton
                variant="gradient"
                color="error"
                onClick={() => {
                  // remove pickslip details
                  const filtered = pickslipDetails.filter(
                    (x) => !selectedCurrentLocationId.includes(x.id)
                  );
                  setPickslipDetails(filtered);

                  // add remove pickslip details location to available location
                  // if location already exists, then update quantity
                  // filter location
                  // const data = pickslipDetails.filter((x) =>
                  //   selectedCurrentLocationId.includes(x.id)
                  // );
                  // update quantity
                  // const d = locations.map((x) => {
                  //   if (selectedCurrentLocationId.includes(x.id)) {
                  //     x.remainingStockQuantity += data.find((a) => a.id === x.id).quantityPicked;
                  //   }
                  //   return x;
                  // });
                  // if location not exists in available location
                  // const data2 = data.filter((x) => !locations.map((x) => x.id).includes(x.id));

                  // setLocations([
                  //   ...d,
                  //   ...data2.map((x) => ({ ...x, remainingStockQuantity: x.quantityPicked })),
                  // ]);
                  // const details = data.map((x) => {
                  //   const { remainingStockQuantity, ...value } = x;
                  //   return {
                  //     ...value,
                  //     quantityAllocate: 0,
                  //     quantityPicked: 0,
                  //   };
                  // });
                  // setPickslipDetails([...pickslipDetails, ...details]);
                }}
                disabled={selectedCurrentLocationId.length === 0}
              >
                Remove Location
              </MDButton>
              <MDButton
                sx={{ ml: 1 }}
                variant="gradient"
                color="info"
                onClick={() => {
                  setAlert(null);
                  setAllocate([]);
                  allocateMutation.mutate(
                    {
                      orderNumber: orderNumber ?? "",
                      waveNumber: waveNumber ?? "",
                      skuCode,
                      items: pickslipDetails,
                    },
                    {
                      onSuccess: (data) => setAllocate(data.data.data),
                      onError,
                    }
                  );
                }}
                disabled={pickslipDetails.length === 0}
              >
                Save And Preview
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>

        <Divider textAlign="left" sx={{ background: "#9ebeeb", opacity: "unset" }} />

        <Box sx={{ "& .bold": { fontWeight: 1000, background: "mintcream" } }}>
          {isFetching && <LoadingDialog />}
          <MDTypography color="info" variant="h5">
            Allocate Details
          </MDTypography>
          <StatusDataGrid
            columns={allocateColumns}
            rows={
              allocate.length > 0
                ? [
                    ...allocate,
                    {
                      id: "Total",
                      label: "Total",
                      quantityAllocate: totalQuantityAllocate,
                      quantityPicked: totalAllocateQuantityPicked,
                    },
                  ]
                : []
            }
            processRowUpdate={(updatedRow, originalRow) => {
              let qtyUpdated = numberValidation(updatedRow.quantityPicked);
              if (qtyUpdated > updatedRow.quantityAllocate) {
                qtyUpdated = updatedRow.quantityAllocate;
              }
              const details = allocate.map((x) => {
                if (x.id === updatedRow.id) {
                  x.quantityPicked = qtyUpdated;
                  originalRow.quantityPicked = qtyUpdated;
                }
                return x;
              });
              setAllocate(details);
              return originalRow;
            }}
            onProcessRowUpdateError={(x) => {
              console.log(x);
            }}
            getCellClassName={({ row, field }) => {
              if (row.id === "Total") {
                if (
                  field === "orderNumber" ||
                  field === "quantityAllocate" ||
                  field === "quantityPicked"
                ) {
                  return "bold";
                }
              }
              return "";
            }}
          />
        </Box>

        <MDBox display="flex" justifyContent="flex-end" mt={2}>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              setPreview([]);
              saveMutation.mutate(
                {
                  orderNumber: orderNumber ?? "",
                  waveNumber: waveNumber ?? "",
                  skuCode,
                  totalQuantityPicked,
                  items: allocate,
                  locationItems: pickslipDetails,
                },
                {
                  onSuccess: (data) => setPreview(data.data.data),
                  onError,
                }
              );
            }}
            disabled={allocate.length === 0}
          >
            Submit
          </MDButton>
        </MDBox>

        <Divider textAlign="left" sx={{ background: "#9ebeeb", opacity: "unset" }} />
        {saveAlert}

        <Box sx={{ "& .bold": { fontWeight: 1000, background: "mintcream" } }}>
          {isFetching && <LoadingDialog />}
          <MDTypography color="info" variant="h5">
            Preview Details
          </MDTypography>
          <StatusDataGrid
            columns={previewColumns}
            rows={
              preview.length > 0
                ? [
                    ...preview,
                    {
                      id: "Total",
                      label: "Total",
                      quantityAllocate: totalAllocate,
                      quantityPicked: totalQuantityPicked2,
                    },
                  ]
                : []
            }
            processRowUpdate={(updatedRow, originalRow) => {
              let qtyUpdated = numberValidation(updatedRow.quantityPicked);
              if (qtyUpdated > updatedRow.quantityAllocate) {
                qtyUpdated = updatedRow.quantityAllocate;
              }
              const details = preview.map((x) => {
                if (x.id === updatedRow.id) {
                  x.quantityPicked = qtyUpdated;
                  originalRow.quantityPicked = qtyUpdated;
                }
                return x;
              });
              setPreview(details);
              return originalRow;
            }}
            onProcessRowUpdateError={(x) => {
              console.log(x);
            }}
            getCellClassName={({ row, field }) => {
              if (row.id === "Total") {
                if (
                  field === "orderNumber" ||
                  field === "quantityAllocate" ||
                  field === "quantityPicked"
                ) {
                  return "bold";
                }
              }
              return "";
            }}
          />
        </Box>

        <MDBox display="flex" justifyContent="flex-end" mt={2}>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              updateMutation.mutate(
                {
                  orderNumber: orderNumber ?? "",
                  waveNumber: waveNumber ?? "",
                  skuCode,
                  items: preview,
                },
                {
                  onSuccess: (data) => {
                    setPreview([]);
                    setAllocate([]);
                    queryClient.invalidateQueries(["amend"]);
                    setSaveAlert(<Success data={data} onChange={setSaveAlert} />);
                  },

                  onError,
                }
              );
            }}
            disabled={preview.length === 0}
          >
            Submit
          </MDButton>
        </MDBox>
      </Box>
    </Dialog>
  );
};
